var linkToPartial = (function ($) {
    /* Public scope and variables */
    var self = {};

    // Provide key value pairs of words to search for paired to the class to add.
    var keywords = {
        'Downloads': 'link-to-downloads',
        'Useful Links': 'link-to-useful-links'
    };

    /* Private functions */
    function init() {
        // Bootstrap the component
        bootstrap();
    }

    /**
     * Bootstrap the component
     */
    function bootstrap() {
        // Bind the UI
        bindUI();

        // Bind the events
        bindEvents($('.clickable'));
    }

    /**
     * Bind the html
     */
    function bindUI() {
        createClickableText($('main'));
    }

    /*
    * Bind the events
    * */
    function bindEvents(clickables) {
        console.log(clickables);
        clickables.each(function () {
            $(this).on('click', function () {
                this.className.split(' ').forEach(function (classname) {
                    if (classname.indexOf('link-to-') !== -1) {
                        scrollToPartial(classname);
                    }
                });
            });
        });
    }

    /*
    * Wrap the keywords in selectable spans.
    * */
    function createClickableText(pageContentBlocks) {
        $.each(keywords, function (index, value) {
            pageContentBlocks.each(function () {
                var replace = new RegExp(index, "g");
                $(this).html($(this).html().replace(replace, '<a tabindex="0" href="#" class="clickable ' + value + '">' + index + '</a>'));
            });
        });
    }

    /*
    * Scroll to the required on-page partial.
    * */
    function scrollToPartial(classname) {
        var destinationName = 'panel-' + classname.replace('link-to-', ''),
            destination = document.getElementsByClassName(destinationName);

        if (destination) {
            $('html, body').animate({
                scrollTop: $(destination).offset().top - ($(window).innerHeight() * 0.1) + 'px'
            }, 500, function () {
                drawAttentionTo(destinationName)
            });
        }
    }

    /*
    * Flash the on-page partial upon scroll arrival.
    * */
    function drawAttentionTo(destination) {
        $(document.getElementsByClassName(destination)).find('.panel-heading').fadeIn(100).fadeOut(100).fadeIn(100);
    }

    init();

    // Return the object itself.
    return self;

}(jQuery, window, {}));
